import { render } from "./DateTime.vue?vue&type=template&id=7d1a2a7c"
import script from "./DateTime.vue?vue&type=script&lang=js"
export * from "./DateTime.vue?vue&type=script&lang=js"
script.render = render

export default script